import axios from "@/api/config";

const schoolPageMenu = {
  getSchoolPageMenuList(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/getSchoolPageMenuList`,
      {
        params: data
      }
    );
  },
  getListType(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageMenu/getSchoolPageMenuListByType`,
      {
        params: data
      }
    );
  }
};

export default schoolPageMenu;



// WEBPACK FOOTER //
// ./src/api/schoolPageMenu.js